import { Layout, SecondaryTopNav } from "@certn/cascadia-react";
import { CascadiaLayout } from "@certn/cascadia-tokens";
import { PropsWithChildren } from "react";

import { AppFooter } from "../app-footer";

interface Props extends PropsWithChildren {
  layout?: CascadiaLayout;
  onClose: () => void;
}

export function FullScreenModalLayout(props: Props) {
  const { layout = "applicant/narrow", children } = props;

  return (
    <Layout
      layout={layout}
      header={
        <SecondaryTopNav
          testID=""
          leftIcon="close"
          onleftIconOnPress={props.onClose}
        />
      }
      footer={<AppFooter />}
    >
      {children}
    </Layout>
  );
}
